// Resolves the human-readable name of the layer currently materialized into
// a set of Zones, by majority sourceLayerId — robust against a stray
// leftover zone (e.g. from legacy data) rather than trusting array order.
export const resolveActiveLayerName = (sectionZones, layers) => {
  if (!sectionZones || sectionZones.length === 0) return 'No layer uploaded yet';

  const counts = {};
  sectionZones.forEach(z => {
    const key = z.sourceLayerId || '';
    counts[key] = (counts[key] || 0) + 1;
  });

  const topKey = Object.keys(counts).sort((a, b) => counts[b] - counts[a])[0];
  const layer = topKey ? layers.find(l => l._id === topKey) : null;
  return layer ? layer.name : 'Unnamed layer';
};
